var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card',{staticClass:"mt-28",attrs:{"title":_vm.title}},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"report_detail_remind"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }